// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"qJ-z","smallCardRow":"rJ-z","largeCardRow":"sJ-z","productSearchRow":"tJ-z","curatedRow":"uJ-z"};